import { Typography, Box } from "@mui/material";
import { PieChart } from "@mui/x-charts/PieChart";

// helper: generate color from string (stable across renders)
const stringToColor = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const hue = Math.abs(hash) % 360; // always 0-359
    return `hsl(${hue}, 65%, 55%)`; // colorful & consistent
};

const CountywiseUI = ({ chartData, filters }) => {
    const data = filters.city
        ? chartData?.CityCount
        : filters.state
            ? chartData?.CityCount
            : filters?.country
                ? chartData?.StateCount
                : chartData?.CountryCount;

    const pieData = (data || []).map((item, idx) => ({
        id: item.name ?? idx,
        value: item.count,
        label: item.name ?? "Unknown",
        color: stringToColor(item.name ?? "Unknown"), // ✅ dynamic stable color
    }));


    if (!data || data.length === 0) {
        return (
            <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                width="100%"
                height={200}
            >
                <Typography
                    variant="h6"
                    sx={{
                        fontFamily: "Public Sans",
                        color: "#999999",
                        fontWeight: 600,
                    }}
                >
                    No Data Available
                </Typography>
            </Box>
        );
    }


    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="space-around"
            width="100%"
        >
            {/* Pie Chart */}
            <Box maxWidth={180} maxHeight={200} width={180} height={180}>
                <PieChart
                    series={[
                        {
                            data: pieData,
                            innerRadius: 30,
                            outerRadius: "80%",
                            paddingAngle: 1,
                            cornerRadius: 5,
                            startAngle: -45,
                            endAngle: 360,
                            cx: "40%",
                            cy: "40%",
                        },
                    ]}
                    slotProps={{ legend: { hidden: true } }}
                    width={330}
                    height={250}
                />
            </Box>

            {/* Custom Scrollable Legend */}
            <Box
                flex={1}
                maxWidth={170}
                width={150}
                display="flex"
                flexDirection="column"
                justifyContent="center"
            >
                <Box
                    sx={{
                        border: "1px solid #e0e0e0",
                        borderRadius: "8px",
                        padding: "8px 12px",
                        fontFamily: "Public Sans",
                        maxHeight: 200,
                        overflowY: "auto", // ✅ scrollbar when too many
                    }}
                >
                    {data?.length > 0 &&
                        data.map((item) => (
                            <Box
                                key={item?.name}
                                display="flex"
                                alignItems="center"
                                mb={1}
                            >
                                <Box
                                    sx={{
                                        width: 10,
                                        height: 10,
                                        borderRadius: "50%",
                                        backgroundColor: stringToColor(item?.name ?? "Unknown"),
                                        mr: 1,
                                    }}
                                />
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: "#4D4D4D",
                                        fontFamily: "Public Sans",
                                        fontWeight: 500,
                                    }}
                                >
                                    {item?.name}: {item?.count}
                                </Typography>
                            </Box>
                        ))}
                </Box>
            </Box>
        </Box>
    );
};

export default CountywiseUI;
